export default __webpack_public_path__ + "static/media/foreign-influence.77c06fa2.svg";